<template>
  <main data-preview-id="kb-index-categories-container">
    <div>
      <div class="content-container">
        <div class="kb-index kb-index--tiles">
          <router-link
            v-for="category in categoryParents"
            :key="category.id"
            :to="`/category/${category.id}`"
            class="kb-index__category kb-index__category--3col"
            :data-preview-id="`kb-index__category-${category.id}`"
          >
            <div>
              <div
                class="kb-index__category-icon"
                style="color: #0584cc;"
              >
                <span
                  id="hs_cos_wrapper_"
                  class="
                    hs_cos_wrapper
                    hs_cos_wrapper_widget
                    hs_cos_wrapper_type_icon
                  "
                  style=""
                  data-hs-cos-general-type="widget"
                  data-hs-cos-type="icon"
                >
                  <i :class="`fa ${category.icon ? category.icon : ''}`" />
                </span>
              </div>
              <h3>{{ category.name }}</h3>
              <h5 class="kb-index__category-description">
                {{ category.description }}
              </h5>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from '@axios'
export default {
  name: 'HomePage',
  components: {},
  data() {
    return {
      title: '',
      faq_categories: [],
    }
  },
  computed: {
    categoryParents() {
      return this.faq_categories.map((category) => {
        return {
          id: category.id,
          name: category.name,
          description: category.description,
          icon: category.icon,
        }
      })
    },
  },
  mounted() {
    this.title = 'FAQ'
    this.fetchFaqCategories()
  },
  methods: {
    async fetchFaqCategories() {
      try {
        const { data } = await axios.get('/api/v2/faq_categories')
        this.faq_categories = data.faq_categories
      } catch (error) {
        //
      }
    },
  },
}
</script>
